import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SESSION_KEY = "scopegrid_session_id";

function ensureSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

const http = axios.create({
  baseURL: API,
  timeout: 120000,
});

http.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers["x-session-id"] = ensureSessionId();
  return cfg;
});

export async function fetchProblemTypes() {
  const { data } = await http.get("/problem-types");
  return data.problem_types;
}

export async function startCase({ problem_type, raw_prompt }) {
  const { data } = await http.post("/cases/start", { problem_type, raw_prompt });
  return data;
}

export async function submitAnswers(caseId, answers) {
  const { data } = await http.post(`/cases/${caseId}/submit-answers`, { answers });
  return data;
}

export async function getCase(caseId) {
  const { data } = await http.get(`/cases/${caseId}`);
  return data;
}

export async function getCaseStatus(caseId) {
  const { data } = await http.get(`/cases/${caseId}/status`);
  return data;
}

export async function pollTopAnswers(caseId) {
  const { data } = await http.get(`/cases/${caseId}/top-answers`);
  return data;
}

export async function unlockCase(caseId, { name, email }) {
  const { data } = await http.post(`/cases/${caseId}/unlock`, { name, email });
  return data;
}

export async function rerunCase(caseId, answers) {
  const { data } = await http.post(`/cases/${caseId}/rerun`, { answers });
  return data;
}

// ---- Feedback + Tector bridge ----

export async function submitFeedback(payload) {
  const { data } = await http.post(`/feedback`, payload);
  return data;
}

export async function submitTectorBridge({ name, email, case_id }) {
  const { data } = await http.post(`/tector-bridge`, { name, email, case_id });
  return data;
}

// ---- Admin ----

const ADMIN_TOKEN_KEY = "scopegrid_admin_token";

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export async function fetchAdminLeads() {
  const token = getAdminToken();
  const { data } = await http.get(`/admin/leads`, {
    headers: { "x-admin-token": token },
  });
  return data;
}

export async function fetchAdminStats() {
  const token = getAdminToken();
  const { data } = await http.get(`/admin/stats`, {
    headers: { "x-admin-token": token },
  });
  return data;
}
